import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  Modal,
  CircularProgress,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../components/global/Pagination";
import PageHeader from "../../components/common/PageHeader";
import StatusChip from "../../components/common/StatusChip";
import baseUrl from "../../slices/baseUrl";
import BannerIcon from "../../images/icons/banner.png";
import CloseIcon from "@mui/icons-material/Close";
import CopyIcon from "../../images/icons/copyIcon.png";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "../../images/icons/search.png";
import DownloadIcon from "@mui/icons-material/Download";
import InfoIcon from "@mui/icons-material/Info";
import {
  fetchRefundReqList,
  fetchRefundReqCount,
  searchRefundRequestList,
  refundRequestsDownload,
} from "../../slices/requestSlice";
import "../../App.css";
import { TitleContext } from "../../components/global/TitleContext";

import {
  refundTransferPayment,
} from "../../ContractAction/PaymentContractAction";

function RefundRequests() {
  const userId = sessionStorage?.getItem("userId");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [blockUnblockOpen, setBlockUnblockOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [idToChangeStatus, setIdToChangeStatus] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [note, setNote] = useState("");
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addRejectNoteOpen, setAddRejectNoteOpen] = useState(false);
  // search
  const [showIcon, setShowIcon] = useState(true);
  const [searchText, setSearchText] = useState("");
  const textInputRef = useRef(null);
  const [searchInitiated, setSearchInitiated] = useState(false);

  // Refund requester
  const [refundRequester, setRefundRequester] = useState("");

  // metamask payment
  const [recipientAddress, setRecipientAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [isConnected, setIsConnected] = useState(false);

  let searchResult = useSelector((state) => state?.request?.search);

  const refundReqRecords = useSelector(
    (state) => state?.request?.refundReqRecords
  );
  const totalRefundReqCount = useSelector(
    (state) => state?.request?.totalRefundReqCount
  );
  const loadingStatus = useSelector((state) => state?.request?.status);

  const [openDialogs, setOpenDialogs] = useState(
    Array(data?.length||0).fill(false)
  );

  const handleIconClick = (index) => {
    const newOpenDialogs = [...openDialogs];
    newOpenDialogs[index] = true;
    setOpenDialogs(newOpenDialogs);
  };

  const handleCloseDialog = (index) => {
    const newOpenDialogs = [...openDialogs];
    newOpenDialogs[index] = false;
    setOpenDialogs(newOpenDialogs);
  };

  //total records and count
  useEffect(() => {
    searchResult = [1];
    const checkConnection = async () => {
      if (typeof window.ethereum !== "undefined") {
        setIsConnected(true);
      }
    };
    checkConnection();

    dispatch(fetchRefundReqCount());
  }, []);

  useEffect(() => {
    if (totalRefundReqCount > 1) {
      setTotalPages(
        (prevPages) => (prevPages = Math.ceil(totalRefundReqCount / 20))
      );
    }
  }, [totalRefundReqCount]);

  // sorted records
  useEffect(() => {
    dispatch(fetchRefundReqList(currentPage));
  }, [currentPage]);

  useEffect(() => {
    if (refundReqRecords && refundReqRecords?.length > 0) {
      setData(refundReqRecords);
    }
  }, [refundReqRecords]);

  // search
  useEffect(() => {
    if (searchInitiated) {
      if (searchResult?.length < 1) {
        setData(searchResult);
        setSnackbarMessage("No result found");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      } else {
        setData(searchResult);
        setTotalPages(1)
      }
    }
  }, [searchResult]);
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Refund requests");
  }, [setTitle]);

  // approve refund request
  const handleAcceptRequest = async (id, status) => {
    const gotReceipt = await refundTransferPayment(
      refundRequester?.walletAddress,
      refundRequester?.feesPaid
    );

    if (
      (gotReceipt?.txHash && gotReceipt?.status.toString() === "1") ||
      (gotReceipt?.txHash && gotReceipt?.status.toString() === "1n") ||
      (gotReceipt?.txHash && gotReceipt?.status.toString() === "2n") ||
      (gotReceipt?.txHash && gotReceipt?.status.toString() === true)
    ) {
      saveRefundPaymentDetails(
        userId,
        refundRequester?.id,
        gotReceipt?.txHash,
        gotReceipt?.receiver,
        gotReceipt?.sender,
        gotReceipt?.status,
        refundRequester?.feesPaid,
        gotReceipt?.explorerTxHash
      );
      setBlockUnblockOpen(false);
    }
  };

  const saveRefundPaymentDetails = async (
    __userId,
    __refundId,
    __transactionHash,
    __receiver,
    __sender,
    __status,
    __value,
    __transactionHashUrl
  ) => {
    let data = {
      transactionHash: __transactionHash,
      receiver: __receiver,
      sender: __sender,
      status: "Completed",
      value: __value,
      transactionHashUrl: __transactionHashUrl,
    };

    try {
      const response = await fetch(
        `${baseUrl}/pay/paymentForRefund/${__userId}/${__refundId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response?.ok) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }

      handleRefundUpdate(__userId, __refundId, "solve");

      const result = await response?.json();
    } catch (error) {
      setSnackbarMessage("Oops something went wrong in payment for refund");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      console.error("Error creating post:", error);
    } finally {
    }
  };

  const handleRefundUpdate = async (adminUserId, id, paidStatus) => {
    try {
      const response = await fetch(
        `${baseUrl}/refund/update/${adminUserId}/${id}/${paidStatus}`,
        {
          method: "PUT",
        }
      );
      if (response?.status === 200) {
        const message = "Refund processed successfully!";
        setSnackbarMessage(message);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setBlockUnblockOpen(false);
        setTimeout(() => {
          setSnackbarMessage("");
          handleSnackbarClose();
        }, 2000);
        dispatch(fetchRefundReqList(currentPage));
      } else {
        const error = await response?.json();
        setSnackbarMessage(error?.developermsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An error occurred.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleTransfer = async (userId, id, status) => {
    try {
      const response = await fetch(
        `${baseUrl}/request/update/${userId}/${id}/${status}`,
        {
          method: "PUT",
        }
      );
      if (response?.status === 200) {
        const message = "Request accepted successfully!";
        setSnackbarMessage(message);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setBlockUnblockOpen(false);
        setTimeout(() => {
          setSnackbarMessage("");
          handleSnackbarClose();
        }, 2000);
        dispatch(fetchRefundReqList(currentPage));
      } else {
        const error = await response?.json();
        setSnackbarMessage(error?.developermsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An error occurred.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  // reject refund request
  const handleRejectRequest = async (id, status, note) => {
    try {
      const response = await fetch(
        `${baseUrl}/refund/update/${userId}/${id}/${status}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            note: note,
          }),
        }
      );

      if (response?.ok) {
        setAddRejectNoteOpen(false);
        addRejectNoteClose();
        const message = "Request rejected successfully!";
        setSnackbarMessage(message);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setBlockUnblockOpen(false);
        setTimeout(() => {
          setSnackbarMessage("");
          handleSnackbarClose();
        }, 2000);
        dispatch(fetchRefundReqList(currentPage));
      } else {
        const error = await response?.json();
        setSnackbarMessage(error?.developermsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An error occurred while processing your request.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleOpen1 = (item, statusvalue) => {
    item && setRefundRequester(item);
    if (statusvalue === "reject" && note === "") {
      setIdToChangeStatus(item);
      setStatus(statusvalue);
      setSnackbarMessage("Please enter reason for rejection");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else {
      setIdToChangeStatus(item);
      setStatus(statusvalue);
      setBlockUnblockOpen(true);
    }
  };
  const handleClose1 = () => {
    setBlockUnblockOpen(false);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const myStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
        backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
        color: theme.palette.text.primary,
    width: "40vw",
    height: "200px",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.5)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 30px",
    outline: "none",
    borderRadius: "20px",
  };
  

  const convertDate = (timedate) => {
    const date = new Date(timedate);
    const day = String(date?.getDate()).padStart(2, "0");
    const month = String(date?.getMonth() + 1).padStart(2, "0");
    const year = String(date?.getFullYear());
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  // copy wallet address
  const handleTextClick = (text, msg) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setSnackbarMessage(msg);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        setSnackbarMessage("Unable to copy text to clipboard");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };

  // show ... in wallet address
  function truncateAddress(address) {
    if (!address) return "";
    if (address?.length <= 20) return address; // No need to truncate if the address length is less than or equal to 12
    const truncatedLength = 8; // Number of characters to display before ellipsis
    const truncatedAddress = `${address?.substring(
      0,
      truncatedLength
    )}....${address?.substring(address?.length - 4)}`;
    return truncatedAddress;
  }

  // Reject note dialog open
  const handleOpenNoteDialog = (id,statusvalue) => {
    setIdToChangeStatus(id);
    setStatus(statusvalue);
    setAddRejectNoteOpen(true);
    // setBlockUnblockOpen(true);
  };
  const handleTextFieldChange = (event) => {
    setNote(event.target.value);
  };
  const addRejectNoteClose = () => {
    setIdToChangeStatus("");
    setStatus("");
    setNote("");
    setAddRejectNoteOpen(false);
  };

  // search
  const handleBlur = (e) => {
    if (searchText?.length <= 0) {
      setShowIcon(true);
      setData(data);
    }
    setSearchText(e.target.value);
  };

  const handleChangeSearchText = (e) => {
    if (e.target.value === "") {
      setData(refundReqRecords);
      setShowIcon(true);
    } else {
      setShowIcon(true);
    }
    setSearchText(e.target.value);
  };

  const handleSearch = () => {
    if (searchText === "") {
      setSnackbarMessage("Enter something to search");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    setShowIcon(false);
    textInputRef.current.blur();
    setSearchInitiated(true);
    dispatch(searchRefundRequestList(searchText));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    dispatch(fetchRefundReqList(currentPage));
    setSearchText("");
    setShowIcon(true);
    setSearchInitiated(false);
    setSnackbarOpen(false);
    setTotalPages(Math.ceil(totalRefundReqCount / 20));
  };

  const handleClickDownload = async () => {
    dispatch(refundRequestsDownload());
  };

  return (
    <Box sx={{ position: "relative", p: { xs: 2, sm: 4 }, maxWidth: "1600px", margin: "0 auto" }} className="animate-fade-in">
      <PageHeader 
        title="Refund Requests"
        subtitle="Manage and process advertiser refund submissions"
        action={
          <Box sx={{ display: "flex", gap: { xs: 1, sm: 2 }, alignItems: "center" }}>
            <Tooltip title="Export Data">
              <IconButton 
                onClick={handleClickDownload}
                sx={{ 
                  width: 44,
                  height: 44,
                  bgcolor: 'rgba(34, 211, 238, 0.05)',
                  color: 'primary.main',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  '&:hover': { bgcolor: 'rgba(34, 211, 238, 0.1)', transform: 'translateY(-2px)' },
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
            <TextField
              sx={{
                width: { xs: "100%", sm: "280px" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)',
                  backdropFilter: 'blur(8px)',
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: `1px solid ${theme.palette.divider}`,
                  "&:hover": { borderColor: 'rgba(34, 211, 238, 0.3)', backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' },
                  "&.Mui-focused": { borderColor: 'primary.main', boxShadow: '0 0 15px rgba(34, 211, 238, 0.15)' },
                  "& fieldset": { border: "none" },
                },
                "& .MuiInputBase-input": { fontSize: '14px', py: 1.5 }
              }}
              size="small"
              value={searchText}
              placeholder="Search..."
              inputRef={textInputRef}
              onChange={handleChangeSearchText}
              onKeyDown={handleKeyPress}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" onClick={showIcon ? handleSearch : handleClearSearch} sx={{ cursor: "pointer", ml: 1 }}>
                    {showIcon ? (
                      <img src={SearchIcon} alt="search" style={{ height: "18px", opacity: 0.6 }} />
                    ) : (
                      <CloseIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        }
      />

      {loadingStatus === "loading" ? (
        <Box sx={{ height: "60vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress size={40} thickness={4} sx={{ color: 'primary.main' }} />
        </Box>
      ) : (
        <Box className="glass-vanguard" sx={{ mt: 4, borderRadius: "24px", overflow: "hidden", p: 1, mb: 10 }}>
          <Box sx={{ overflowX: "auto" }}>
            <Box sx={{ minWidth: "1100px", p: 2 }}>
              <Grid
                container
                sx={{
                  px: 3,
                  py: 2,
                  background: theme.palette.mode === 'dark' ? 'rgba(34, 211, 238, 0.05)' : 'rgba(34, 211, 238, 0.08)',
                  borderRadius: "16px",
                  mb: 2,
                  "& .MuiTypography-root": {
                    color: 'primary.main',
                    fontWeight: 700,
                    fontSize: '11px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em'
                  },
                }}
              >
                <Grid item xs={0.6} textAlign="center"><Typography>Sr.</Typography></Grid>
                <Grid item xs={2.2}><Typography sx={{ pl: 1 }}>Reason</Typography></Grid>
                <Grid item xs={2}><Typography sx={{ pl: 1 }}>Wallet</Typography></Grid>
                <Grid item xs={1.2} textAlign='right'><Typography sx={{ pr: 1 }}>Amount</Typography></Grid>
                <Grid item xs={1.2} textAlign="center"><Typography>Date</Typography></Grid>
                <Grid item xs={1.6} textAlign="center"><Typography>Tx Hash</Typography></Grid>
                <Grid item xs={1.4} textAlign="center"><Typography>Status</Typography></Grid>
                <Grid item xs={1.8} textAlign="center"><Typography>Actions</Typography></Grid>
              </Grid>

              <Box sx={{ px: 1 }}>
                {data?.map((item, index) => (
                  <Grid
                    container
                    key={item?.id}
                    sx={{
                      alignItems: "center",
                      px: 2,
                      py: 2,
                      borderRadius: "12px",
                      mb: 1,
                      transition: "all 0.2s ease",
                      backgroundColor: index % 2 === 0 
                        ? 'transparent' 
                        : (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)'),
                      "&:hover": {
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(34, 211, 238, 0.03)' : 'rgba(34, 211, 238, 0.05)',
                        transform: 'translateX(4px)',
                      }
                    }}
                  >
                    <Grid item xs={0.6} textAlign="center">
                      <Typography variant="body2" sx={{ opacity: 0.5, fontWeight: 600 }}>
                        {20 * currentPage - 20 + index + 1}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.2}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {item?.issue}
                        </Typography>
                        {item?.image && (
                          <Tooltip title="View Attachment">
                            <IconButton onClick={() => handleIconClick(index)} size="small" sx={{ p: 0.5, color: 'primary.main' }}>
                              <img src={BannerIcon} alt="Icon" style={{ height: "14px" }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Dialog
                          open={openDialogs[index] || false}
                          onClose={() => handleCloseDialog(index)}
                          PaperProps={{
                            sx: {
                              background: 'rgba(10, 15, 28, 0.95)',
                              backdropFilter: 'blur(20px)',
                              borderRadius: '24px',
                              border: '1px solid rgba(255, 255, 255, 0.1)',
                              color: 'text.primary',
                            },
                          }}
                        >
                          <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={{ fontWeight: 700, letterSpacing: '0.05em' }}>ATTACHMENT PREVIEW</Typography>
                            <IconButton onClick={() => handleCloseDialog(index)} sx={{ color: 'rgba(255,255,255,0.5)', "&:hover": { color: 'primary.main' } }}>
                              <CloseIcon />
                            </IconButton>
                          </DialogTitle>
                          <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
                            <img src={`${baseUrl}/refund/getImage/${item?.id}`} alt="Preview" style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain' }} />
                          </DialogContent>
                        </Dialog>
                      </Box>
                    </Grid>
                    <Grid item xs={2}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', opacity: 0.8 }}>
                          {truncateAddress(item?.walletAddress)}
                        </Typography>
                        <Tooltip title="Copy Address">
                          <IconButton size="small" onClick={() => handleTextClick(item?.walletAddress, "Wallet address copied")} sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}>
                            <img src={CopyIcon} alt="copy" style={{ width: '11px', height: '11px' }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid item xs={1.2} textAlign='right'>
                      <Typography variant="body1" sx={{ fontWeight: 800, color: 'primary.main' }}>
                        ${item?.feesPaid}
                      </Typography>
                    </Grid>
                    <Grid item xs={1.2} textAlign="center">
                      <Typography variant="caption" sx={{ fontWeight: 600, opacity: 0.6 }}>
                        {convertDate(item?.createdOn)}
                      </Typography>
                    </Grid>
                    <Grid item xs={1.6}>
                      <Typography variant="caption" sx={{ fontFamily: 'monospace', opacity: 0.6, display: 'block', textAlign: 'center' }}>
                        {truncateAddress(item?.transactionHash)}
                      </Typography>
                    </Grid>
                    <Grid item xs={1.4} textAlign="center">
                      <StatusChip 
                        status={item?.status === "pending" ? "pending" : item?.status === "completed" ? "active" : "rejected"}
                        label={item?.status === "pending" ? "Pending" : item?.status === "completed" ? "Approved" : "Rejected"}
                      />
                    </Grid>
                    <Grid item xs={1.8} textAlign="center">
                      {item?.status === "pending" ? (
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => handleOpenNoteDialog(item?.id, "reject")}
                            sx={{ borderRadius: '8px', minWidth: '75px', textTransform: 'none', fontWeight: 700 }}
                          >
                            Reject
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setRecipientAddress(item?.walletAddress);
                              setAmount(item?.feesPaid);
                              handleOpen1(item, "solve");
                            }}
                            sx={{ borderRadius: '8px', minWidth: '75px', textTransform: 'none', fontWeight: 700 }}
                          >
                            Approve
                          </Button>
                        </Box>
                      ) : (
                        <Tooltip title={item?.status === "rejected" ? `Reason: ${item?.note}` : "Refund complete"} placement="top">
                          <IconButton size="small" sx={{ color: 'primary.main', opacity: 0.7 }}>
                            <InfoIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Grid>
                  </Grid>
                ))}
                {snackbarOpen && (
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Alert
                      onClose={handleCloseSnackbar}
                      severity={snackbarSeverity}
                    >
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Modal
        open={blockUnblockOpen}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
             sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundImage: theme.palette.mode === 'dark' 
                        ? "linear-gradient(to top right, #0a0b2a, #1b6a88)"
                        : "linear-gradient(to top right, #ffffff, #f0f4f8)",
                    color: "text.primary",
                    width:{xs:'90%',sm:'60%',md:'40vw'},
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "30px",
                    outline: "none",
                    borderRadius: "20px",
                }}
            >
          <Typography
            id="modal-modal-title"
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
            variant="body1"
            component="h2"
          >
            Are you sure you want to {status === "reject" ? "Reject" : "Accept"}{" "}
            this refund request ?
          </Typography>
          <Box
            style={{
              width: "70%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={() => {
                if (status === "reject") {
                  handleRejectRequest(idToChangeStatus, status, note);
                } else {
                  handleAcceptRequest(idToChangeStatus, status);
                }
              }}
              type="submit"
              sx={{
                width: "130px",
                height: "35px",
                backgroundColor: theme.palette.primary.main,
                borderRadius: "4px",
                fontWeight: 600,
                color: theme.palette.primary.contrastText,
                textTransform: "none",
                boxShadow: "none",
                marginRight: "30px",
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
          >
              Yes
            </Button>{" "}
            <Button
              type="cancel"
              onClick={handleClose1}
              sx={{
                width: "130px",
                height: "35px",
                color: theme.palette.text.primary,
                backgroundColor: "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: "4px",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)',
                },
              }}
            >
              No
          </Button>
          </Box>
        </Box>
      </Modal>
      {/* reject note */}
      <Dialog
        maxWidth="xs"
        PaperProps={{
          style: {
            height: isLargeScreen ? "60vh" : "auto",
            width: isLargeScreen ? "50vw" : "",
                backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
            color: theme.palette.text.primary,
            borderRadius: "30px",
            padding: "10px 30px",
          },
      }}
        open={addRejectNoteOpen}
        onClose={addRejectNoteClose}
      >
        <>
          <DialogTitle
            style={{
              textAlign: "center",
              color: theme.palette.text.primary,
            }}
          >
            Enter Reason for Rejection
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{
                fontSize: "12px",
                textAlign: "left",
                color: theme.palette.text.secondary,
              marginBottom: "10px",
                marginTop: "20px",
              }}
            >
              Enter the reason for Rejecting refund request:
            </DialogContentText>
            <Box
              component="form"
              noValidate
              sx={{
                mt: 0.5,
                backgroundColor: "rgba(150,150,150,0.1)",
                borderRadius: "8px",
              }}
            >
              <TextField
                placeholder="Explain your reason"
                name="description"
                value={note}
                onChange={handleTextFieldChange}
                fullWidth
                multiline
                sx={{
                  borderRadius: "8px",
                  border: "none",
                  color: theme.palette.text.primary,
                  "& .MuiInputBase-input": {
                    color: theme.palette.text.primary,
                    fontSize: "12px",
                    minHeight: "50px",
                  },
                "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiFilledInput-root": {
                    height: "30px",
                  },
                }}
                autoComplete="off"
                size="small"
                variant="outlined"
              />
            </Box>

            <Button
              size="small"
              fullWidth
              sx={{
                textTransform: "none",
                marginTop: "20px",
                fontWeight: 600,
                padding: "7px",
                borderRadius: "8px",
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
              variant="contained"
              onClick={(e) => handleOpen1(idToChangeStatus, status)}
            >
              Submit
            </Button>

            <div style={{ textAlign: "right" }}>
              <Button
                size="small"
                onClick={addRejectNoteClose}
                sx={{
                  textDecoration: "none",
                  textTransform: "none",
                  color: theme.palette.primary.main,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
            >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </>
      </Dialog>
      <Box sx={{ height: "30px" }}></Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 4,
          mb: 4,
          p: 2,
          background: 'rgba(255, 255, 255, 0.02)',
          borderRadius: "16px",
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.05)'
        }}
      >
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Box>
      {snackbarOpen && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            elevation={6}
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
}

export default RefundRequests;
